





























import { defineComponent, type PropType } from "vue-demi";
import { Navigation } from "swiper/modules";
import Swiper from "swiper";
import throttle from "lodash.throttle";

export default defineComponent({
  name: "GGRowSlider",
  props: {
    list: {
      type: Array as PropType<unknown[]>,
      required: true,
    },
    offsetBetweenElements: {
      type: Number,
      default: 0,
    },
  },
  data(): {
    slider: null | Swiper;
    isEnd: boolean;
    isStart: boolean;
    buttonNext: null | HTMLElement;
    buttonPrev: null | HTMLElement;
    throttledResize: (() => void) | null;
  } {
    return {
      slider: null,
      isEnd: false,
      isStart: true,
      buttonNext: null,
      buttonPrev: null,
      throttledResize: null,
    };
  },
  mounted() {
    this.buttonNext = this.$refs.buttonNext as HTMLElement;
    this.buttonPrev = this.$refs.buttonPrev as HTMLElement;

    this.slider = new Swiper(this.$refs.slider as HTMLElement, {
      slideClass: "constructor-swiper-slide",
      wrapperClass: "constructor-swiper-wrapper",
      slideActiveClass: "constructor-swiper-slide-active",
      slideVisibleClass: "constructor-swiper-slide-visible",
      slideBlankClass: "constructor-swiper-slide-active",
      slideFullyVisibleClass: "constructor-swiper-slide-fully-visible",
      slideNextClass: "constructor-swiper-slide-next",
      slidePrevClass: "constructor-swiper-slide-next",
      modules: [Navigation],
      spaceBetween: this.$props.offsetBetweenElements,
      slidesPerView: "auto",
      navigation: {
        nextEl: this.buttonNext,
        prevEl: this.buttonPrev,
      },
      on: {
        init: () => {
          this.updateNavigationState();
        },
        slideChange: () => {
          this.updateNavigationState();
        },
        reachEnd: () => {
          this.updateNavigationState();
        },
        reachBeginning: () => {
          this.updateNavigationState();
        },
      },
    });

    this.throttledResize = throttle(() => this.slider?.autoplay?.resume(), 300);
    window.addEventListener("resize", this.throttledResize);

    this.updateNavigationState();
  },
  destroyed() {
    if (this.slider) {
      this.slider.destroy(true, true);
      this.slider = null;
    }
    if (this.throttledResize) {
      window.removeEventListener("resize", this.throttledResize);
    }
  },
  methods: {
    updateNavigationState() {
      if (this.slider) {
        const swiperWrapper = this.$refs.slider as HTMLElement | undefined;
        const slides = swiperWrapper?.querySelectorAll(
          ".constructor-swiper-slide"
        );
        if (slides?.length && swiperWrapper) {
          const totalSlidesWidth = Array.from(slides).reduce(
            (width, slide) => width + (slide as HTMLElement).offsetWidth,
            0
          );

          const viewportWidth = swiperWrapper.offsetWidth;

          this.isEnd = this.slider.isEnd || totalSlidesWidth < viewportWidth;
          this.isStart = this.slider.isBeginning;
        }
      }
    },
  },
});
